import { FormControl, ValidationErrors } from '@angular/forms';
import { FormGroupExtended } from './form-group-extended.class';

export class FormControlExtended<T> extends FormControl<T | null> {
  warnings: ValidationErrors | null = null;
  additionalData: Record<string, string>;
  showErrorFlag = false;
  isSubmitted: boolean;
  get showErrors(): boolean {
    if (this.invalid && this.errors != null) {
      if (this.errors.required != null || this.errors.isUnique != null) {
        return this.showErrorFlag || (this.parent as FormGroupExtended).isSubmitted;
      }
      return this.dirty || this.touched;
    }
    return false;
  }
}
